import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import { getCountryCode } from "helpers/getCountryCode";
import { useEffect } from "react";
import { useMindlerApi } from "./apiv2";

export const useGetMarkets = (includeDisabled = false) => {
  const mindlerApi = useMindlerApi();
  const query = useQuery(
    mindlerApi.application.markets.queryOptions({ includeDisabled }),
  );

  useEffect(() => {
    if (query.data) {
      const codeISO2 = getCountryCode();
      const market = query.data.find((m) => m.codeISO2 === codeISO2);
      window.localStorage.setItem(
        "languageId",
        market?.defaultLanguageId?.toString() ?? "",
      );
    }
  }, [query.data]);

  return query;
};
